module.exports = __webpack_public_path__ + "static/media/fluence.c9a74c40.png";